const DEFAULT_BUY_DOMAIN = 'https://buy.tablelist.com'

// process.env for Next.js; import.meta.env for Vite (often undefined in Next server bundles)
export const env = {
  mode: process.env,
  domain: process.env.NEXT_PUBLIC_SITE_DOMAIN || DEFAULT_BUY_DOMAIN,
  tablelistApiUrl:
    process.env.NEXT_PUBLIC_TL_API_URL ?? 'https://api.tablelist.com',
  tablelistApiKey: process.env.NEXT_PUBLIC_TL_API_KEY,
  bugsnagApiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY,
  stripeApiKey: process.env.NEXT_PUBLIC_STRIPE_KEY,
  pubnubPubKey: process.env.NEXT_PUBLIC_PUBNUB_PUB_KEY,
  pubnubSubKey: process.env.NEXT_PUBLIC_PUBNUB_SUB_KEY,
}

export const isProd =
  env.tablelistApiUrl?.includes('api.tablelist.com') ?? false
